var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinanceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#181A20"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8) scale(0.18957)",
    fill: "#F0B90B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.73 53.2 63.32 28.62l24.6 24.6 14.3-14.31L63.32 0l-38.9 38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 63.31 14.3 49l14.31 14.31L14.3 77.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.73 73.41 63.32 98l24.6-24.6 14.31 14.29-.01.02-38.9 38.9-38.9-38.88-.02-.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.99 63.32 112.29 49l14.31 14.3-14.31 14.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.83 63.3 63.32 48.78 52.59 59.51l-1.24 1.23-2.54 2.54-.02.02.02.03 14.51 14.5 14.52-14.51z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceIcon);
export default __webpack_public_path__ + "static/media/binance-icon.6f6563fbc8e71bf8840eb07d29356ca3.svg";
export { ForwardRef as ReactComponent };